export const toLocalISOdateString = (date: Date): string => {
  return date.toLocaleString("sv").replace(" ", "T").substring(0, 10);
};
